import { Stack, Typography, ToggleButtonGroup, ToggleButton } from "@mui/material";
import SettingCard from "@/components/SettingCard";
import ClassSettings from "@/components/editor/settings/ClassSettings";
import SpacingSettings from "@/components/editor/settings/SpacingSettings/SpacingSettings";
import { TextField, Chip } from "@mui/material";
import { useNode, useEditor } from "@craftjs/core";
import slugify from "slugify";
import { useState } from "react";

export const FormSettings = () => {
  const [cursorPosition, setCursorPosition] = useState<number | null>(null);

  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    props: node.data.props,
    id: node.id,
  }));

  const { query } = useEditor();

  const descendants = query.node(id).descendants(true);

  // Filter nodes that have custom.formField = true
  const fieldNodes = descendants
    .map((descendantId: string) => query.node(descendantId).get())
    .filter((node: any) => node.data.custom?.formField);

  return (
    <Stack spacing={2}>
      <SettingCard title="Clase Css">
        <ClassSettings />
      </SettingCard>
      <SettingCard title="Configuración">
        <Stack spacing={2}>
          <ToggleButtonGroup
            color="primary"
            value={props.submissionType || 'email'}
            exclusive
            onChange={(e, value) => {
              if (value !== null) {
                setProp((props: any) => (props.submissionType = value));
              }
            }}
            fullWidth
            size="small"
          >
            <ToggleButton value="email">Email</ToggleButton>
            <ToggleButton value="queryString">Query Strings</ToggleButton>
          </ToggleButtonGroup>

          {props.submissionType === 'email' ? (
            <Stack spacing={2}>
              <TextField
                label="Para"
                value={props.to || ''}
                onChange={(e) => setProp((props: any) => (props.to = e.target.value))}
                fullWidth
                size="small"
              />
              <TextField
                label="Asunto"
                value={props.subject || ''}
                onChange={(e) => setProp((props: any) => (props.subject = e.target.value))}
                fullWidth
                size="small"
              />
              <TextField
                label="Mensaje"
                value={props.message || ''}
                onChange={(e) => setProp((props: any) => (props.message = e.target.value))}
                fullWidth
                size="small"
                multiline
                minRows={4}
                onBlur={(e) => {
                  setCursorPosition(e.target.selectionStart);
                }}
              />
              <Typography variant="body1" color="text.secondary">
                Campos disponibles:
              </Typography>
              <Stack direction="row" flexWrap="wrap" gap={1}>
                {fieldNodes.map((node: any) => {
                  const fieldLabel = node.data.props.label;
                  const childId = node.id;

                  if (!fieldLabel) return null;

                  const fieldId = slugify(fieldLabel ?? "", { lower: true });

                  return (
                    <Chip
                      key={childId}
                      label={fieldLabel}
                      color="primary"
                      onClick={() => {
                        setProp((props: any) => {
                          const currentMessage = props.message || '';
                          const tag = `{{${fieldId}}}`;

                          if (cursorPosition !== null && cursorPosition >= 0 && cursorPosition <= currentMessage.length) {
                            const before = currentMessage.substring(0, cursorPosition);
                            const after = currentMessage.substring(cursorPosition);
                            props.message = before + tag + after;
                          } else {
                            props.message = currentMessage + tag;
                          }
                        });
                      }}
                      size="small"
                      clickable
                    />
                  );
                })}
              </Stack>
            </Stack>
          ) : (
            <Stack spacing={2}>
              <Typography variant="body2" color="text.secondary">
                Los valores de los campos del formulario se almacenarán en la URL como parámetros de consulta (query strings) cuando el usuario envíe el formulario.
              </Typography>
              <TextField
                label="Parámetros adicionales"
                value={props.customQueryParams || ''}
                onChange={(e) => setProp((props: any) => (props.customQueryParams = e.target.value))}
                fullWidth
                size="small"
                placeholder="utm_source=newsletter&utm_campaign=promo"
                helperText="Parámetros personalizados que se añadirán a la URL (formato: key=value&key2=value2)"
              />
            </Stack>
          )}

        </Stack>
      </SettingCard >
      <SettingCard title="Espaciado">
        <SpacingSettings />
      </SettingCard>
    </Stack>
  );
};

export default FormSettings;
